import { arrayCross, commentVNode } from "@/core/utils";

let permissions = [];

export default {
    install(Vue, { store, store_path }) {
        if (!store) {
            console.error("[Dr Permissions Plugin] No store specified");

            return false;
        }

        if (!store_path) {
            console.error("[Dr Permissions Plugin] No store_path specified");

            return false;
        }

        Vue.directive("drPermission", {
            inserted(el, bindings, vnode) {
                if (!CheckPermission(bindings.value)) {
                    commentVNode(el, vnode);
                }
            },

            update(el, bindings, vnode) {
                if (!CheckPermission(bindings.value)) {
                    commentVNode(el, vnode);
                }
            }
        });

        store.watch(
            (state, getters) => getters[store_path],
            perms => {
                permissions = perms;
            }
        );
    }
};

export class Rule {
    constructor(rule) {
        this.rule = rule;
    }
    check(permissions) {

        return permissions.indexOf(this.rule) !== -1;
    }
}

export class RuleOneOf {
    constructor(rules) {
        this.rules = rules;
    }
    check(permissions) {
        return arrayCross(permissions, this.rules).length > 0;
    }
}

export class RuleAllOf {
    constructor(rules) {
        this.rules = rules;
    }
    check(permissions) {

        return arrayCross(permissions, this.rules).length === this.rules.length;
    }
}

export function CheckPermission(permission) {
    if (!permission || !permissions || permissions.length === 0) {
        return false;
    }

    if (typeof permission === "string") {
        permission = new Rule(permission);
    }

    if (Array.isArray(permission)) {
        permission = new RuleAllOf(permission);
    }

    if (permission instanceof Rule) {
        return permission.check(permissions);
    }

    if (permission instanceof RuleOneOf) {
        return permission.check(permissions);
    }

    if (permission instanceof RuleAllOf) {
        return permission.check(permissions);
    }

    return true;
}
